import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import CreateNotification from './CreateNotification';
import { API_URL } from '../Config';
import { toast } from 'sonner';

export default function EditNotification() {
    const { search, state } = useLocation();
    const query = new URLSearchParams(search);
    const notificationIdRaw = query.get('id') || state?.notificationId || '';
    const notificationId = notificationIdRaw ? String(notificationIdRaw) : '';

    const [detail, setDetail] = useState(state?.notificationDetail ?? null);
    const [loading, setLoading] = useState(Boolean(notificationId));

    useEffect(() => {
        if (!notificationId) {
            setLoading(false);
            return;
        }
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                toast.error('Not authenticated');
                setLoading(false);
                return;
            }
            try {
                const response = await fetch(
                    `${API_URL}/${`notifications/${encodeURIComponent(notificationId)}`.replace(/^\/+/, '')}`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                const result = await response.json();
                if (cancelled) return;
                if (result?.data !== undefined && result?.data !== null) {
                    setDetail(result.data);
                } else {
                    toast.error(result?.message || 'Failed to load notification');
                    setDetail(null);
                }
            } catch {
                if (!cancelled) toast.error('Failed to load notification');
                setDetail(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [notificationId]);

    if (!notificationId) {
        return (
            <Box className="page-container" sx={{ p: 2 }}>
                Missing notification id
            </Box>
        );
    }

    if (loading) {
        return (
            <Box className="page-container" sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }

    const apiPath = `notifications/${encodeURIComponent(notificationId)}`;

    return (
        <CreateNotification
            pageTitle="Edit Notification"
            submitLabel="Update"
            apiPath={apiPath}
            initialPayload={detail || undefined}
        />
    );
}
